var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Styles } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import { getPaymentMethodId } from "../../../data/helpers";
import { clearInlineErrors } from "../../../store/AppState/actions";
import { WidgetContext } from "../../Widget";
import { useDispatch, useSelector } from "react-redux";
var useTypedSelector = useSelector;
var Square = function (_a) {
    var id = _a.id, label = _a.label, setPaymentMethodId = _a.setPaymentMethodId, locationId = _a.locationId, setSquareCard = _a.setSquareCard, setError = _a.setError, postalCode = _a.postalCode, setSquareCardReady = _a.setSquareCardReady, payments = _a.payments;
    var _b = __read(useState(false), 2), showInput = _b[0], setShowInput = _b[1];
    var _c = __read(useState(), 2), localCard = _c[0], setCard = _c[1];
    var darkMode = useContext(WidgetContext).darkMode;
    var dispatch = useDispatch();
    var inlineErrors = useTypedSelector(function (store) { return store.app.inlineErrors; });
    var styleCard = function (card) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, card.configure({
                        postalCode: postalCode ? postalCode : "",
                        style: {
                            ".input-container": {
                                borderColor: darkMode ? "#393e45" : "#e5e6e7",
                                borderRadius: "3px",
                            },
                            ".input-container.is-focus": {
                                borderColor: darkMode ? "#f5f5f5" : "#4a525a",
                                borderWidth: "1px",
                            },
                            ".input-container.is-error": {
                                borderColor: "#e71d36",
                                borderWidth: "2px",
                            },
                            input: {
                                color: darkMode ? "#FFFFFF" : "#24272b",
                                backgroundColor: darkMode ? "#2d2f32" : "#ffffff",
                                fontSize: Styles.sFontSize,
                            },
                            "input::placeholder": {
                                color: darkMode ? "rgba(255, 255, 255, 0.34)" : "rgba(36, 39, 43, 0.29)",
                            },
                            "input.is-error": {
                                color: "#e71d36",
                            },
                            ".message-text": {
                                color: darkMode ? "#FFFFFF" : "#24272b",
                            },
                            ".message-text.is-error": {
                                color: Styles.error,
                            },
                            ".message-icon": {
                                color: darkMode ? "#FFFFFF" : "#24272b",
                            },
                            ".message-icon.is-error": {
                                color: "#e71d36",
                            },
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var createCard = function (payments) { return __awaiter(void 0, void 0, void 0, function () {
        var card;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, payments.card()];
                case 1:
                    card = _a.sent();
                    if (!card) return [3 /*break*/, 4];
                    return [4 /*yield*/, card.attach("#square-card-".concat(locationId))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, styleCard(card)];
                case 3:
                    _a.sent();
                    card.addEventListener("errorClassRemoved", function () {
                        dispatch(clearInlineErrors());
                    });
                    card.addEventListener("cardBrandChanged", function (evt) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            getPaymentMethodId("square")
                                .then(function (paymentMethodId) {
                                setPaymentMethodId(paymentMethodId);
                            })
                                .catch(function (errorMessage) {
                                setError(errorMessage);
                            });
                            return [2 /*return*/];
                        });
                    }); });
                    setSquareCard(card);
                    setShowInput(true);
                    setCard(card);
                    setSquareCardReady(true);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (payments) {
            createCard(payments);
        }
    }, [payments]);
    useEffect(function () {
        if (localCard) {
            styleCard(localCard);
        }
    }, [darkMode]);
    useEffect(function () {
        if (localCard && postalCode && (postalCode === null || postalCode === void 0 ? void 0 : postalCode.length) >= 5) {
            localCard.configure({
                postalCode: postalCode ? postalCode : "",
            });
        }
    }, [postalCode]);
    if (!payments) {
        return null;
    }
    return (_jsxs("div", __assign({ className: "field ".concat((inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.squarePaymentError) ? "has-square-error" : "") }, { children: [_jsx("div", { id: "square-card-".concat(locationId) }), (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.squarePaymentError) && _jsx("span", __assign({ className: "error" }, { children: inlineErrors.squarePaymentError }))] })));
};
export default Square;
